<template>
    <vx-popover :hover="props.hover" pinnable :placement="props.placement" arrow :teleport="props.teleport">
        <slot>
            <button
                type="button"
                class="cursor-pointer focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-blue-500"
                :aria-label="`Segment details: ${props.modelValue.name}`"
                data-test="segment-details-trigger"
            >
                <font-awesome-icon class="text-slate-500" :icon="faInfoCircle" />
            </button>
        </slot>

        <template v-slot:content>
            <div class="flex flex-col max-w-lg gap-2">
                <resource-name class="flex-row-reverse" :modelValue="props.modelValue"></resource-name>

                <div class="grid grid-cols-5 gap-2">
                    <div class="col-span-1">Category:</div>
                    <div class="col-span-4">
                        <span>{{ getCategoryLabel(props.modelValue.category) }}</span>
                    </div>

                    <div class="col-span-1">Description:</div>
                    <div class="col-span-4">
                        <span>{{ props.modelValue.description || '-' }}</span>
                    </div>
                </div>
            </div>
        </template>
    </vx-popover>
</template>

<script setup lang="ts">
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { VxPopover, type VxPopoverPlacement } from '@voxie/frontend-components';
import { getCategoryLabel } from '~/constants/categories';
import type { Segment } from '~/services/segments/segmentsClient.types';
import ResourceName from '~/components/general/resources/ResourceName.vue';
import type { PropType } from 'vue';

const props = defineProps({
    modelValue: {
        type: Object as PropType<Segment>,
        required: true,
    },
    hover: {
        type: Boolean,
        default: true,
    },
    placement: {
        type: String as PropType<VxPopoverPlacement>,
        default: 'top',
    },
    teleport: {
        type: Boolean,
        default: true,
    },
});
</script>
